import { render, staticRenderFns } from "./BoggProcessMap.vue?vue&type=template&id=ef374a78&scoped=true&"
import script from "./BoggProcessMap.vue?vue&type=script&lang=js&"
export * from "./BoggProcessMap.vue?vue&type=script&lang=js&"
import style0 from "./BoggProcessMap.vue?vue&type=style&index=0&id=ef374a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef374a78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
